<template>
  <div class="app-container">
    <!-- 顶部栏 -->
    <div class="topbar" style="padding-top: 20px">
      <div>
        <el-input v-model="searchValue" size="mini" prefix-icon="el-icon-search" style="width: 400px"
                  @keyup.enter.native="search()" clearable/>

        <el-button :disabled="!searchValue" type="primary" size="mini" icon="el-icon-search"
                   style="margin-left: 10px" @click="search()">
          搜索
        </el-button>

      </div>
    </div>

    <el-table v-loading="loading" :data="tableData" border stripe class="data-table"
              :header-cell-style="{ background: '#F5F7FA' }">
      <el-table-column label="ID" prop="liveSignMsgID" align="center"></el-table-column>
      <el-table-column label="发起者" align="center">
        <template #default="scope">
          <user-info :user="scope.row"></user-info>
        </template>
      </el-table-column>
      <el-table-column label="签到说明" prop="tipContent" align="center"></el-table-column>
      <el-table-column label="已签到" prop="signCount" align="center"></el-table-column>
      <el-table-column label="发起时间" align="center">
        <template #default="scope">
          {{ scope.row.createTime | formatDateTime }}
        </template>
      </el-table-column>
      <el-table-column label="删除时间" align="center">
        <template #default="scope">
          {{ scope.row.deleteTime | formatDateTime }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template #default="scope">
          <el-button type="success" size="small" @click="go2SignUser(scope.row)">签到用户</el-button>
          <el-button :type="scope.row.isDeleted ? 'warning' : 'danger'" size="small" @click="handleDelete(scope.row)">
            {{ scope.row.isDeleted ? '恢复' : '删除' }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination hide-on-single-page background :total="pageOpt.total" :page-size="pageOpt.pageSize"
                   :current-page="pageOpt.curPage" @current-change="currentPageChange"/>

  </div>
</template>

<script>
import {isVaild} from "@/utils/validate";
import {deleteLiveSignMsgOrBack, getLiveSignMsgList} from "@/api/mai/liveManagement/liveManagement";
import {handleRes} from "@/utils/handleRes";
import UserInfo from "@/components/UserInfo/UserInfo";
import {getNavigationItemObj, setNavigationItemWithObj} from "@/utils/NavigationUtils";

export default {
  name: "SignMsgList",
  components: {UserInfo},
  created() {
    let navigationObj = getNavigationItemObj(this.navigationKey)
    this.pageOpt.curPage = navigationObj.currentPage
    this.searchValue = navigationObj.searchValue

    this.getLiveSignMsgList()
  },
  props: {
    liveID: {
      type: Number
    }
  },
  data() {
    return {
      navigationKey: "LiveSignMsgList",

      tableData: [],
      pageOpt: {
        curPage: 0,
        pageSize: 10,
        total: 0
      },
      loading: false,
      searchValue: "",

    }
  },
  methods: {
    goback() {
      this.$router.go(-1)
    },
    search() {
      this.refreshList()
    },
    refreshList() {
      this.pageOpt.curPage = 1
      this.getLiveSignMsgList();
    },
    currentPageChange(curPage) {
      this.pageOpt.curPage = curPage
      this.getLiveSignMsgList()
    },
    getLiveSignMsgList() {
      this.loading = true;

      setNavigationItemWithObj(this.navigationKey,{
        currentPage: this.pageOpt.curPage,
        searchValue:this.searchValue,
      })

      getLiveSignMsgList({
        keyWord: this.searchValue,
        liveId: this.liveID,
        pageIndex: this.pageOpt.curPage,
        pageSize: this.pageOpt.pageSize
      }).then(res => {
        handleRes(res, () => {
          this.tableData = res.data.rows
          this.pageOpt.total = res.data.total
        })
        this.loading = false;
      })
    },
    go2SignUser(entity) {
      this.$router.push({
        path: 'liveSignUser',
        query: {
          liveID: entity.liveID,
          liveSignMsgID: entity.liveSignMsgID
        },
      })
    },
    handleDelete(entity) {
      deleteLiveSignMsgOrBack({
        liveSignMsgId: entity.liveSignMsgID
      }).then(res => {
        handleRes(res, () => {
          this.getLiveSignMsgList();
          this.$message('操作成功')
        })
      })
    }
  }
}
</script>

<style scoped>

</style>